import styled from 'styled-components';

export const Container = styled.section`
  position: relative;
  width: 18rem;
  background: #fff;
  border-radius: 5px 5px 0 5px;
  display: flex;
  flex-direction: column;
  align-items: center;

  -webkit-box-shadow: 2px 2px 9px -4px #000000;
  box-shadow: 2px 2px 9px -4px #000000;

  & + & {
    margin-left: 1rem;
  }

  @media (max-width: 1200px) {
    width: 16rem;
  }
`;

export const Header = styled.header`
  height: 40px;
  background-color: ${(props) => (props.color ? props.color : 'gray')};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px 5px 0 0;
  padding: 0 8px;
  z-index: 20;

  /* força que todo texto dentro do header seja branco */
  * {
    color: white !important;
  }

  .header {
    border: none;
    background: inherit;
    width: 100%;
  }

  .header > p {
    float: left;
    margin: 0;
    padding: 0;
    font-weight: 400;
  }
`;

export const BodyChat = styled.section`
  height: ${(props) => (props.size ? '320px' : '0px')};
  transition: ease-in-out 0.4s;
  overflow-y: scroll;
  width: 100%;
  scroll-behavior: smooth;
  background: #eceff1;
  display: flex;
  flex-direction: column;

  .area-messages {
    scroll-behavior: smooth;
    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

export const BalloonRight = styled.div`
  border-radius: 10px 10px 0px 10px;
  background-color: #d1f4cc;
  color: #000;
  padding: 0.5rem 0.6rem;
  margin: 0 0 10px auto;
  max-width: 75%;
  font-size: 14px;
  font-family: sans-serif;
  position: relative;
  word-break: break-word;

  audio {
    width: 100%;
    height: 36px;
    min-width: 200px;
    display: block;
    margin-top: 4px;
  }
`;

export const BalloonLeft = styled.div`
  border-radius: 10px 10px 10px 0px;
  background-color: #ffffff;
  color: #000;
  padding: 0.5rem 2.4rem 0.9rem 0.6rem;
  margin: 0 0 10px 0;
  max-width: 75%;
  font-size: 14px;
  font-family: sans-serif;
  position: relative;
  word-break: break-word;
  border: 1px solid #ccc;

  .text-left {
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.3;
    font-size: 14px;
    display: block;
  }

  audio {
    width: 100%;
    height: 36px;
    min-width: 178px;
    display: block;
    margin-top: 4px;
  }
`;

export const InputArea = styled.form`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${(props) => (props.size ? '42px' : '0px')};
  background: #fff;
  font-family: sans-serif;
  box-shadow: 0px -2px 10px 0px rgb(195, 195, 195);

  .form-chat-internal {
    width: 100%;
    padding: 0 10px;
  }

  .input-chat-internal-write {
    outline-style: none;
    border: 0;
    width: 100%;
    background: #fff;
    padding: 5px 10px;
    font-size: 14px;

    &::placeholder {
      font-size: 14px;
      color: #999;
    }
  }

  .chat-buttons {
    display: flex;
    align-items: center;
    gap: 0px;
    margin-right: 6px;

    button {
      margin: 0;
      padding: 4px;
      color: #676666ff !important;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: transform 0.15s ease, box-shadow 0.15s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      }
    }
  }
`;

export const ContentMessages = styled.div`
  width: 100%;
  display: flex;
  margin-top: 5px;
  justify-content: ${(props) => props.align || 'flex-start'};
`;

export const NotificationBadge = styled.div`
  background-color: #ff3b3b;
  border: 2px solid white;
  width: 10px;
  height: 10px;
  border-radius: 50%;
`;

export const Loading = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .spinner {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 3px dashed #7a7a7a;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ButtonSendMessageInternalChatArea = styled.button`
  background-color: ${(props) =>
    props.theme.confirmation_button_color || '#007bff'};
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props) =>
      props.theme.confirmation_button_color || '#007bff'};
    opacity: 0.8;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const MessageStatusRight = styled.span`
  margin-left: 4px;
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  gap: 3px;
  font-size: 11px;
  opacity: 0.8;
  white-space: nowrap;
  flex-shrink: 0;

  svg {
    position: static;
  }
`;

export const MessageStatusLeft = styled.span`
  position: absolute;
  right: 6px;
  bottom: 19px;
  font-size: 11px;
  opacity: 0.6;
  white-space: nowrap;
`;
